<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container-fluid w-100 h-100 pb-3" style="overflow-x: hidden">
        <navbar :title="$t('menu.additional_cost')" class="mb-1"/>
        <div class="col-sm-12 nopads">
            <additional-cost-search
                class="my-2"
                :user="user"
                @search="searchWithParams"/>

            <div class="col-12 d-flex justify-content-end">
                <button class="form-button btn btn-success" @click="addItem">
                    {{ $t('common.add_new') }}
                </button>
            </div>
            <additional-cost-list
                class="my-2"
                :results="results"
                :table-sortable="true"
                @rowClicked="editItem"/>
            <base-modal v-if="editMode" hide-header hide-footer @close="showList" size="lg">
                <additional-cost-editor
                    :additional-cost="result"
                    :is-observer="isObserver"
                    @closeAndUpdate="searchWithParams"
                    @close="showList"
                />
            </base-modal>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import AdditionalCostSearch from "@/components/additionalcost/AdditionalCostSearch";
import {additionalCostHelper} from "@/components/mixins/AdditionalCostMixin";
import AdditionalCostEditor from "@/components/additionalcost/AdditionalCostEditor";
import AdditionalCostList from "@/components/additionalcost/AdditionalCostList";
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'additional-costs',
    components: {BaseModal, Navbar, AdditionalCostList, AdditionalCostEditor, AdditionalCostSearch},
    mixins: [restApi, timeUtils, additionalCostHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
        isObserver: Boolean,
        isWorker: Boolean,
    },
    data: function () {
        return {
            loading: false,
            searchParams: null,
            editMode: false,
            results: [],
            result: null
        }
    },
    methods: {
        searchWithParams: function (params) {
            this.results = []
            this.loading = true
            this.searchParams = params || []
            this.restFetchParams(this.additionalCostUrl, params, this.handleResponse)
        },
        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
            this.showList()
        },
        showList: function () {
            this.editMode = false
        },
        editItem: function (item) {
            this.result = item
            this.editMode = true
        },
        addItem: function () {
            this.result = null
            this.editMode = true
        }
    }
}
</script>
